import {
  GET_ASSESMENT_QUESTIONS,
  GET_ASSESMENT_QUESTIONS_FAILED,
  GET_ASSESMENT_QUESTIONS_SUCCESS,
  POST_ASSESMENT_QUESTIONS,
  POST_ASSESMENT_QUESTIONS_FAILED,
  POST_ASSESMENT_QUESTIONS_SUCCESS,
  GET_ASSESMENT_SHEET_LIST,
  GET_ASSESMENT_SHEET_LIST_SUCCESS,
  GET_ASSESMENT_SHEET_LIST_FAILED,
  CHANGE_THE_STATUS,
  CHANGE_THE_STATUS_SUCCESS,
  CHANGE_THE_STATUS_FAILED,
  GET_THE_SHEET_DATA,
  GET_THE_SHEET_DATA_SUCCESS,
  GET_THE_SHEET_DATA_FAILED,
  UPDATE_THE_SHEET,
  UPDATE_THE_SHEET_SUCCESS,
  UPDATE_THE_SHEET_FAILED,
  GET_SUGGESTION,
  GET_SUGGESTION_SUCCESS,
  GET_SUGGESTION_FAILED,
} from "./actionTypes";

const initialState = {
  assessQuestionsLoading: null,
  assesmentQuestions: null,
  assesmentQuesionsError: null,
  addAssesmentQuestionsSuccess: null,
  addAssesmentQuestionsFailure: null,
  sheets: null,
  sheetsError: null,
  changeStatusSuccess: null,
  changeStatusFailed: null,
  updateSheet: null,
  updateSheetFailed: null,
  sheetData: null,
  sheetDataFailed: null,
  suggestion:null,
  suggestionError:null,
};

const assesmentQuesionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_ASSESMENT_QUESTIONS:
      state = {
        ...state,
        assessQuestionsLoading: true,
        assesmentQuestions: null,
        assesmentQuesionsError: null,
      };
      break;
    case GET_ASSESMENT_QUESTIONS_SUCCESS:
      state = {
        ...state,
        assessQuestionsLoading: false,
        assesmentQuestions: action.payload,
        assesmentQuesionsError: null,
      };
      break;
    case GET_ASSESMENT_QUESTIONS_FAILED:
      state = {
        ...state,
        assessQuestionsLoading: false,
        assesmentQuestions: null,
        assesmentQuesionsError: action.payload,
      };
      break;
    case POST_ASSESMENT_QUESTIONS:
      state = {
        ...state,
        assessQuestionsLoading: true,
        addAssesmentQuestionsSuccess: null,
        addAssesmentQuestionsFailure: null,
      };
      break;
    case POST_ASSESMENT_QUESTIONS_SUCCESS:
      state = {
        ...state,
        assessQuestionsLoading: false,
        addAssesmentQuestionsSuccess: action.payload,
        addAssesmentQuestionsFailure: null,
      };
      break;
    case POST_ASSESMENT_QUESTIONS_FAILED:
      state = {
        ...state,
        assessQuestionsLoading: false,
        addAssesmentQuestionsSuccess: null,
        addAssesmentQuestionsFailure: action.payload,
      };
      break;
    case GET_ASSESMENT_SHEET_LIST:
      state = {
        ...state,
        assessQuestionsLoading: true,
        sheets: null,
        sheetsError: null,
      };
      break;
    case GET_ASSESMENT_SHEET_LIST_SUCCESS:
      state = {
        ...state,
        assessQuestionsLoading: false,
        sheets: action.payload,
        sheetsError: null,
      };
      break;
    case GET_ASSESMENT_SHEET_LIST_FAILED:
      state = {
        ...state,
        assessQuestionsLoading: false,
        sheets: null,
        sheetsError: action.payload,
      };
      break;
    case CHANGE_THE_STATUS:
      state = {
        ...state,
        assessQuestionsLoading: false,
        changeStatusSuccess: null,
        changeStatusFailed: null,
      };
      break;
    case CHANGE_THE_STATUS_SUCCESS:
      state = {
        ...state,
        assessQuestionsLoading: false,
        changeStatusSuccess: action.payload,
        changeStatusFailed: null,
      };
      break;
    case CHANGE_THE_STATUS_FAILED:
      state = {
        ...state,
        assessQuestionsLoading: false,
        changeStatusSuccess: null,
        changeStatusFailed: action.payload,
      };
      break;
    case GET_THE_SHEET_DATA:
      state = {
        ...state,
        assessQuestionsLoading: true,
        sheetData: null,
        sheetDataFailed: null,
      };
      break;
    case GET_THE_SHEET_DATA_SUCCESS:
      state = {
        ...state,
        assessQuestionsLoading: false,
        sheetData: action.payload,
        sheetDataFailed: null,
      };
      break;
    case GET_THE_SHEET_DATA_FAILED:
      state = {
        ...state,
        assessQuestionsLoading: true,
        sheetData: null,
        sheetDataFailed: action.payload,
      };
      break;

    case UPDATE_THE_SHEET:
      state = {
        ...state,
        assessQuestionsLoading: true,
        updateSheet: null,
        updateSheetFailed: null,
      };
      break;
    case UPDATE_THE_SHEET_SUCCESS:
      state = {
        ...state,
        assessQuestionsLoading: false,
        updateSheet: action.payload,
        updateSheetFailed: null,
      };
      break;
    case UPDATE_THE_SHEET_FAILED:
      state = {
        ...state,
        assessQuestionsLoading: false,
        updateSheet: null,
        updateSheetFailed: action.payload,
      };
      break;
      case GET_SUGGESTION:
      state = {
        ...state,
        assessQuestionsLoading: true,
        suggestion: null,
        suggestionError: null,
      };
      break;
    case GET_SUGGESTION_SUCCESS:
      state = {
        ...state,
        assessQuestionsLoading: false,
        suggestion: action.payload,
        suggestionError: null,
      };
      break;
    case GET_SUGGESTION_FAILED:
      state = {
        ...state,
        assessQuestionsLoading: false,
        suggestion: null,
        suggestionError: action.payload,
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default assesmentQuesionsReducer;
